import { SelectBoxComponent } from '@/components';
import Spinner from '@/Icons/spinner.svg';
import { cn } from '@/utils';
import React, { useRef } from "react";

const RollDirection = ({
  isExpanded,
  headline,
  values,
  selection_id,
  selection_label,
  toggleDropdown,
  closeDropdown,
  onItemClick,
  parentId,
  loadingIndex,
  previewIconsPath,
  isFetching,
}) => {
  const selectBoxRef = useRef();
  const PREVIEW_ICONS_PREFIX = '/model/';
  const PREVIEW_ICONS_SUFFIX = '_preview';
  const PREVIEW_ICONS_EXTENSION = '.png';
  const ID = 'roll-direction';

  const handleItemClick = ({ parentId, id, is_selected }, i) => {
    onItemClick({ parentId, id, is_selected });
  };

  const getPreviewImagePath = (id) => {
    return (
      previewIconsPath +
      PREVIEW_ICONS_PREFIX +
      id +
      PREVIEW_ICONS_SUFFIX +
      PREVIEW_ICONS_EXTENSION
    );
  };

  return (
    <>
      <SelectBoxComponent
        id={ID}
        ref={selectBoxRef}
        showIcon={values.length > 1}
        onClick={() => toggleDropdown()}
        onClickOutside={() => closeDropdown()}
        onKeyDown={(e) => {
          // Handle Enter, Space and Escape key
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            toggleDropdown();
          } else if (e.key === 'Escape') {
            e.preventDefault();
            closeDropdown();
          }
        }}
        isDisabled={isFetching}
        disabledClassName="opacity-40 bg-neutral-light cursor-wait"
        buttonDataAttributes={{'data-roll-direction': selection_id}}
        {...{ isExpanded, headline }}
        DropdownContent={
          <div className="absolute z-overlay mt-3xs w-full bg-white shadow border border-neutral-darker rounded overflow-hidden">
            <ul
              role="listbox"
              aria-labelledby={`listbox-${ID}-label`}
              className="dropdown-content overflow-auto m-0 max-h-[50vh] laptop:max-h-[40vh]"
            >
              {values.map(({ label, is_selected, id }, i) => (
                <li
                  key={i}
                  id={`listbox-${ID}-${i}`}
                  tabIndex="0"
                  role="option"
                  aria-selected={is_selected}
                  data-roll-direction={id}
                  className={cn(
                    'relative flex flex-row items-center py-3xs px-lg border-b border-b-neutral-darker cursor-pointer hover:bg-neutral-light',
                    is_selected || loadingIndex === `${parentId}_${id}`
                      ? 'bg-neutral-light ring-2 ring-inset ring-[color:var(--theme-link-border-color-4)] border-b-0'
                      : 'bg-white',
                    loadingIndex === `${parentId}_${id}` ? 'opacity-80' : ''
                  )}
                  onClick={() =>
                    handleItemClick({ parentId, id, is_selected }, i)
                  }
                  onKeyDown={(e) => {
                    // Handle Enter, Space and Escape key
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      handleItemClick({parentId, id, is_selected}, i);
                    } else if (e.key === 'Escape') {
                      e.preventDefault();
                      closeDropdown();
                    }
                  }}
                  onBlur={({ relatedTarget }) => {
                    if (relatedTarget && selectBoxRef.current && !selectBoxRef.current.contains(relatedTarget)) {
                      closeDropdown();
                    }
                  }}
                >
                  <div className="flex-shrink-0 w-[5.65rem] h-[3rem] mr-xs">
                    <img
                      className="object-fill h-full"
                      src={getPreviewImagePath(id)}
                      alt={label}
                    />
                  </div>
                  <div className="flex flex-col leading-5 font-semibold">{label}</div>
                  <If
                    condition={
                      is_selected || loadingIndex === `${parentId}_${id}`
                    }
                  >
                    <div className="absolute inset-y-0 right-0 pr-lg flex items-center">
                      <Choose>
                        <When condition={loadingIndex === `${parentId}_${id}`}>
                          <ft-spinner size="small"></ft-spinner>
                        </When>
                      </Choose>
                    </div>
                  </If>
                </li>
              ))}
            </ul>
          </div>
        }
      >
        <div className="flex items-center">
          <div className="flex-shrink-0 w-[5.65rem] h-[3rem] mr-xs">
            <img
              className="object-fill"
              src={getPreviewImagePath(
                values.find((value) => value.is_selected).id
              )}
              alt={selection_label}
            />
          </div>
          <div className="flex flex-col items-start text-left leading-5">
            {selection_label}
          </div>
        </div>
      </SelectBoxComponent>
    </>
  );
};

export default RollDirection;
